import gql from "graphql-tag";

export default gql`
	query Mis($installed: Boolean!) {
		Mis(installed: $installed) {
			id
			nice_name
			school_count
		}
	}
`;
